import { Injectable } from '@angular/core';
/**
 * Classe utilitaire pour les énumérations.
 */
@Injectable({
    providedIn: 'root',
})
export class EnumHelper {
    /**
     * Indique si 2 énumérations sont identiques.
     * @param enum1: 1ere énumération.
     * @param enum2: 2nde énumération.
     * @returns: true si les 2 énumérations sont identiques.
     */
    public areEquals(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        if (typeof enum1 !== 'number' && !!enum1) {
            operande1 = enumType[enum1.toString()];
        }

        return operande1 === operande2;
    }

    static areEquals2(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        if (typeof enum1 !== 'number' && !!enum1) {
            operande1 = enumType[enum1.toString()];
        }

        return operande1 === operande2;
    }

    public areNotEquals(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        if (typeof enum1 !== 'number' && !!enum1) {
            operande1 = enumType[enum1.toString()];
        }

        return operande1 !== operande2;
    }

    static areNotEquals2(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        if (typeof enum1 !== 'number' && !!enum1) {
            operande1 = enumType[enum1.toString()];
        }

        return operande1 !== operande2;
    }

    public convert(enumSourceType: Object, enumTargetType: Object, enumValue: any): any {
        return enumTargetType[enumValue.toString()];
    }

    /**
     * Indique si la valeur d'une énumération est après une autre valeur.
     * @param enum1: 1ere énumération.
     * @param enum2: 2nde énumération.
     * @returns: true si la 1ere valeur se situe après la seconde.
     */
    public areAfter(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        return operande1 > operande2;
    }

    /**
     * Indique si la valeur d'une énumération est après ou la même qu'une autre valeur.
     * @param enum1: 1ere énumération.
     * @param enum2: 2nde énumération.
     * @returns: true si la 1ere valeur se situe après la seconde ou est la même.
     */
    public areAfterOrEquals(enumType: Object, enum1: any, enum2: any): boolean {
        // Une énum est part défaut représentée par sa representation numérique. Pour pouvoir la comparer à une enum représentée
        // par sa valeur textuelle, on transforme la valeur textuelle de l'enum en valeur numérique (enumType[valeur_textuelle]).
        let operande1 = enum1;
        const operande2 = enum2;

        return operande1 >= operande2;
    }
}
